import api from './api'
import { User, UserRole, ApiResponse, PaginatedResponse } from '../types'

export interface UserFilters {
  page?: number
  limit?: number
  role?: UserRole
  isActive?: boolean
}

export interface CreateUserData {
  email: string
  password: string
  name: string
  role?: UserRole
}

export interface UpdateUserData {
  email?: string
  password?: string
  name?: string
  role?: UserRole
  isActive?: boolean
}

export interface UserStats {
  total: number
  active: number
  admins: number
}

export const userService = {
  async getAll(filters?: UserFilters): Promise<{ users: User[]; pagination: PaginatedResponse<User>['pagination'] }> {
    const params = new URLSearchParams()
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          params.append(key, String(value))
        }
      })
    }
    const response = await api.get<PaginatedResponse<User>>(
      `/configuration/users?${params.toString()}`
    )
    return {
      users: response.data.data,
      pagination: response.data.pagination,
    }
  },

  async getStats(): Promise<UserStats> {
    const response = await api.get<ApiResponse<UserStats>>('/configuration/users/stats')
    return response.data.data
  },

  async getById(id: string): Promise<User> {
    const response = await api.get<ApiResponse<User>>(`/configuration/users/${id}`)
    return response.data.data
  },

  async create(data: CreateUserData): Promise<User> {
    const response = await api.post<ApiResponse<User>>('/configuration/users', data)
    return response.data.data
  },

  async update(id: string, data: UpdateUserData): Promise<User> {
    const response = await api.put<ApiResponse<User>>(`/configuration/users/${id}`, data)
    return response.data.data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/configuration/users/${id}`)
  },

  async toggleActive(id: string): Promise<User> {
    const response = await api.patch<ApiResponse<User>>(`/configuration/users/${id}/toggle`)
    return response.data.data
  },
}

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  ADMIN: 'Administrador',
  EMPLOYEE: 'Empleado',
}
